<div class="acc-overviewtabs">
  <div class="row table-sanofi">
    <div class="col-md-12 col-lg-4">
      <h3 class="c-heading c-heading-h2">
        {{ 'accountOverview.Financials.label' | cxTranslate }}
      </h3>
    </div>
    <div class="col-md-12 col-lg-8 nav-alignment">
      <div class="prodCard-tabs tab_right_float">
        <ul
          class="nav nav-tabs d-flex justify-content-begin justify-content-lg-end text-fixed-medium"
        >
          <li
            class="nav-item px-3 nav-Item-Border"
            [ngClass]="{ 'nav-Item-Border': selectedTab === 'INVOICES' }"
            data-tab="tab_1"
            (click)="tabNavigation('INVOICES')"
          >
            <p class="mb-1 pb-1 tab-Name">
              {{ 'accountOverview.Financials.invoice_label' | cxTranslate }}
            </p>
          </li>

          <li
            class="nav-item px-3"
            [ngClass]="{ 'nav-Item-Border': selectedTab === 'CREDITS' }"
            data-tab="tab_3"
            (click)="tabNavigation('CREDITS')"
          >
            <p class="mb-1 pb-1 tab-Name">
              {{ 'accountOverview.Financials.credits_label' | cxTranslate }}
            </p>
          </li>
          <li
            class="nav-item px-3"
            [ngClass]="{ 'nav-Item-Border': selectedTab === 'STATEMENTS' }"
            data-tab="tab_4"
            (click)="tabNavigation('STATEMENTS')"
          >
            <p class="mb-1 pb-1 tab-Name">
              {{ 'accountOverview.Financials.statements_label' | cxTranslate }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div id="tab_1" class="tab_content current">
    <app-loader
      *ngIf="!isLoadingDone && selectedTab !== 'STATEMENTS'"
    ></app-loader>
    <div
      class="text-center no-invoices"
      *ngIf="
        !!paymentList &&
        paymentList.length === 0 &&
        isLoadingDone &&
        selectedTab === 'INVOICES'
      "
    >
      {{ 'accountOverview.Financials.no_invoice_found' | cxTranslate }}
    </div>
    <div
      class="text-center no-credits"
      *ngIf="
        !!creditList &&
        creditList.length === 0 &&
        isLoadingDone &&
        selectedTab === 'CREDITS'
      "
    >
      {{ 'accountOverview.Financials.no_credit_found' | cxTranslate }}
    </div>
    <div
      class="row xls-pdf-invoice text-right"
      *ngIf="showXlsPdf && isLoadingDone && selectedTab !== 'STATEMENTS'"
    >
      <div class="col-md-12 ad-files-text darkblue full-wd my-4">
        <a
          title="XLS"
          id="invoiceXLS"
          aria-label="download account overview invoices as"
          data-di-id="#invoiceXLS"
          class="c-link"
          (click)="generateExcel()"
        >
          <span>{{
            'accountOverview.Financials.excel_label' | cxTranslate
          }}</span
          >&nbsp; <fa-icon [icon]="faFileExcel" class="icon"></fa-icon></a
        >&nbsp;&nbsp;
        <a
          id="invoicePDF"
          aria-label="download account overview invoices as"
          data-di-id="#invoicePDF"
          class="c-link"
        >
          <span class="acc-icon-text" (click)="generatePDF()">{{
            'accountOverview.Financials.pdf_label' | cxTranslate
          }}</span
          >&nbsp;<fa-icon [icon]="faFilePdf" class="icon"></fa-icon>
        </a>
      </div>
    </div>
    <section class="row">
      <section
        class="col-md-12 col-xs-12 col-sm-12 fin-Table-Pad"
        id="invoice-table"
      >
        <section
          class="payment-section"
          *ngIf="
            !!paymentList &&
            paymentList.length > 0 &&
            isLoadingDone &&
            selectedTab === 'INVOICES'
          "
        >
          <!-- Desktop -->
          <table
            aria-describedby="invoicesTable"
            id="applyCreditsTable"
            class="credits-table c-table c-table--branded d-none d-lg-table"
            [ngClass]="{ 'not-pdf': isPDF === false }"
          >
            <thead>
              <tr>
                <th
                  scope="col"
                  id="blineDate"
                  (click)="sortColumn($event, 'blineDate', paymentList, 'Date')"
                >
                  {{
                    'accountOverview.Financials.invoices.date_label'
                      | cxTranslate
                  }}
                  &nbsp;
                  <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                </th>
                <th
                  scope="col"
                  id="docNo"
                  (click)="sortColumn($event, 'docNo', paymentList, 'normal')"
                >
                  {{
                    'accountOverview.Financials.invoices.invoice_no'
                      | cxTranslate
                  }}
                  &nbsp;
                  <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                </th>
                <th
                  scope="col"
                  id="dueDate"
                  (click)="sortColumn($event, 'dueDate', paymentList, 'Date')"
                >
                  {{
                    'accountOverview.Financials.invoices.due_date' | cxTranslate
                  }}
                  &nbsp;
                  <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                </th>
                <!-- <th scope="col" class="text-right" id="amount"
                  (click)="sortColumn($event, 'amount', paymentList, 'Number')">
                  {{
                  "accountOverview.Financials.invoices.invoice_amount"
                  | cxTranslate
                  }}
                  &nbsp;
                  <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                </th> -->
                <th
                  scope="col"
                  class="text-right"
                  id="amountDue"
                  (click)="sortColumn($event, 'amount', paymentList, 'Number')"
                >
                  {{
                    'accountOverview.Financials.invoices.amount_due'
                      | cxTranslate
                  }}
                  &nbsp;
                  <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                </th>
                <th scope="col" *ngIf="!isPDF" class="pl-2">
                  {{
                    'accountOverview.Financials.invoices.make_a_payment'
                      | cxTranslate
                  }}
                  &nbsp;
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of paymentList; let i = index">
                <td class="pay">{{ data?.blineDate }}</td>
                <td class="pay">
                  <a
                    *ngIf="
                      data?.docType === 'RV' ||
                      data?.docType === 'RD' ||
                      data?.docType === 'RF'
                    "
                    href="javascript: void(0);"
                    class="underline"
                    (click)="invoicePdf(data.refDocNo)"
                  >
                    {{ data.refDocNo }}
                  </a>
                  <a
                    *ngIf="
                      data?.docType === 'DZ' && data?.allocNmbr?.startsWith('7')
                    "
                    href="javascript: void(0);"
                    class="underline"
                    (click)="invoicePdf(data.allocNmbr)"
                  >
                    {{ data.allocNmbr }}
                  </a>
                  <span
                    *ngIf="
                      data?.docType === 'DR' ||
                      data?.docType === 'DG' ||
                      data?.docType === 'DY'
                    "
                  >
                    {{ data.refDocNo }}
                  </span>
                  <span
                    *ngIf="
                      data?.docType === 'DZ' &&
                      !data?.allocNmbr?.startsWith('7')
                    "
                  >
                    {{ data.allocNmbr }}
                  </span>
                  <span *ngIf="data?.docType === 'YR'">
                    {{ data.refhdr }}
                  </span>
                </td>
                <td class="pay">
                  <span
                    [ngClass]="{
                      red: !!data?.dueDate && dateComparison(data?.dueDate)
                    }"
                    >{{ data?.dueDate }}
                    <ng-template #popSaveContent>
                      <span class="popover-content">{{
                        'makeAPayment.past_due_date' | cxTranslate
                      }}</span>
                    </ng-template>
                    <span
                      [ngbPopover]="popSaveContent"
                      triggers="manual"
                      #p1="ngbPopover"
                      placement="top"
                      (click)="toggle(p1)"
                      container="body"
                      popoverClass="popover-links-invoice"
                      *ngIf="!!data?.dueDate && dateComparison(data?.dueDate)"
                    >
                      <img
                        src="icons/warning_red.png"
                        alt="warningIcon"
                        class="warningIconEvent"
                      />
                    </span>
                  </span>
                </td>
                <!-- <td class="pay inv-text-end amount-Wrap">
                  {{ data?.amount | currency }}
                </td> -->
                <td class="pay inv-text-end amount-Wrap">
                  {{ data?.amount | currency }}
                </td>
                <td class="pay" *ngIf="!isPDF">
                  <a
                    [routerLink]="['/my-account/invoices']"
                    href="javascript: void(0);"
                  >
                    <span class="payment-checkbox-name">{{
                      'accountOverview.Financials.invoices.pay_now'
                        | cxTranslate
                    }}</span></a
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Mobile -->
          <table
            aria-describedby="invoicesTable"
            id="applyInvoiceRWD"
            class="c-table c-table--branded c-table--branded--two-col d-table d-lg-none"
            [ngClass]="{ 'not-pdf': isPDF === false }"
          >
            <tr *ngFor="let data of paymentList; let i = index">
              <td class="two-column-lay header">
                {{
                  'accountOverview.Financials.invoices.date_label' | cxTranslate
                }}
              </td>
              <td class="two-column-lay">{{ data?.blineDate }}</td>
              <td class="two-column-lay header">
                {{
                  'accountOverview.Financials.invoices.invoice_no' | cxTranslate
                }}
              </td>
              <td class="two-column-lay">
                <a
                  *ngIf="
                    data?.docType === 'RV' ||
                    data?.docType === 'RD' ||
                    data?.docType === 'RF'
                  "
                  href="javascript: void(0);"
                  class="underline"
                  (click)="invoicePdf(data.refDocNo)"
                >
                  {{ data.refDocNo }}
                </a>
                <a
                  *ngIf="
                    data?.docType === 'DZ' && data?.allocNmbr?.startsWith('7')
                  "
                  href="javascript: void(0);"
                  class="underline"
                  (click)="invoicePdf(data.allocNmbr)"
                >
                  {{ data.allocNmbr }}
                </a>
                <span
                  *ngIf="
                    data?.docType === 'DR' ||
                    data?.docType === 'DG' ||
                    data?.docType === 'DY'
                  "
                >
                  {{ data.refDocNo }}
                </span>
                <span
                  *ngIf="
                    data?.docType === 'DZ' && !data?.allocNmbr?.startsWith('7')
                  "
                >
                  {{ data.allocNmbr }}
                </span>
                <span *ngIf="data?.docType === 'YR'">
                  {{ data.refhdr }}
                </span>
              </td>
              <td class="two-column-lay header">
                {{
                  'accountOverview.Financials.invoices.due_date' | cxTranslate
                }}
              </td>
              <td class="two-column-lay">
                <span
                  [ngClass]="{
                    red: !!data?.dueDate && dateComparison(data?.dueDate)
                  }"
                  >{{ data?.dueDate }}
                  <ng-template #popSaveContent>
                    <span class="popover-content">{{
                      'makeAPayment.past_due_date' | cxTranslate
                    }}</span>
                  </ng-template>
                  <span
                    [ngbPopover]="popSaveContent"
                    triggers="manual"
                    #p1="ngbPopover"
                    placement="top"
                    (click)="toggle(p1)"
                    container="body"
                    popoverClass="popover-links-invoice"
                    *ngIf="!!data?.dueDate && dateComparison(data?.dueDate)"
                  >
                    <img
                      src="icons/warning_red.png"
                      alt="warningIcon"
                      class="warningIconEvent"
                    />
                  </span>
                </span>
              </td>
              <!-- <td class="two-column-lay header">
                {{
                  "accountOverview.Financials.invoices.invoice_amount"
                    | cxTranslate
                }}
              </td>
              <td class="two-column-lay">{{ data?.amount | currency }}</td> -->
              <td class="two-column-lay header">
                {{
                  'accountOverview.Financials.invoices.amount_due' | cxTranslate
                }}
              </td>
              <td class="two-column-lay">{{ data?.amount | currency }}</td>
              <td class="two-column-lay header">
                {{
                  'accountOverview.Financials.invoices.make_a_payment'
                    | cxTranslate
                }}
              </td>
              <td class="two-column-lay">
                <a
                  [routerLink]="['/my-account/invoices']"
                  href="javascript: void(0);"
                >
                  <span class="payment-checkbox-name">{{
                    'accountOverview.Financials.invoices.pay_now' | cxTranslate
                  }}</span></a
                >
              </td>
            </tr>
          </table>
        </section>
      </section>
    </section>
    <section id="pdf-dummy" *ngIf="isPDF"></section>

    <section
      *ngIf="
        !!creditList &&
        creditList.length > 0 &&
        isLoadingDone &&
        selectedTab === 'CREDITS'
      "
      id="credits-table"
      class="credits-section"
    >
      <table
        aria-describedby="creditsTable"
        id="applyCreditsTable"
        class="credits-table c-table c-table--branded d-none d-lg-table not-pdf"
        [ngClass]="{ 'not-pdf': isPDF === false }"
      >
        <thead>
          <tr>
            <th
              scope="col"
              (click)="sortColumn($event, 'blineDate', creditList, 'Date')"
              id="creditDate"
            >
              {{ 'makeAPayment.credit_date' | cxTranslate }} &nbsp;
              <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
            </th>
            <th
              scope="col"
              id="creditNo"
              (click)="sortColumn($event, 'docNo', creditList, 'normal')"
            >
              {{ 'makeAPayment.credit#' | cxTranslate }}&nbsp;
              <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
            </th>
            <th
              scope="col"
              class="text-left"
              id="creditAmt"
              (click)="sortColumn($event, 'amount', creditList, 'Number')"
            >
              {{ 'makeAPayment.credit_amount' | cxTranslate }}
              <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of creditList; let i = index">
            <td>
              {{ data?.blineDate }}
            </td>
            <td>
              <a
                *ngIf="
                  data?.docType === 'RV' ||
                  data?.docType === 'RD' ||
                  data?.docType === 'RF'
                "
                href="javascript: void(0);"
                class="underline"
                (click)="creditPdf(data.refDocNo)"
              >
                {{ data.refDocNo }}
              </a>
              <a
                *ngIf="
                  data?.docType === 'DZ' && data?.allocNmbr?.startsWith('7')
                "
                href="javascript: void(0);"
                class="underline"
                (click)="creditPdf(data.allocNmbr)"
              >
                {{ data.allocNmbr }}
              </a>
              <span
                *ngIf="
                  data?.docType === 'DR' ||
                  data?.docType === 'DG' ||
                  data?.docType === 'DY'
                "
              >
                {{ data.refDocNo }}
              </span>
              <span
                *ngIf="
                  data?.docType === 'DZ' && !data?.allocNmbr?.startsWith('7')
                "
              >
                {{ data.allocNmbr }}
              </span>
              <span *ngIf="data?.docType === 'YR'">
                {{ data.refhdr }}
              </span>
            </td>
            <td class="text-left">{{ data?.amount | currency }}</td>
          </tr>
        </tbody>
      </table>
      <table
        aria-describedby="creditsTable"
        id="applyCreditsRWD"
        class="c-table c-table--branded c-table--branded--two-col d-table d-lg-none not-pdf"
        [ngClass]="{ 'not-pdf': isPDF === false }"
      >
        <tr *ngFor="let data of creditList; let i = index">
          <td class="two-column-lay header">
            {{ 'makeAPayment.credit_date' | cxTranslate }}
          </td>
          <td class="two-column-lay">{{ data?.blineDate }}</td>
          <td class="two-column-lay header">
            {{ 'makeAPayment.credit#' | cxTranslate }}
          </td>
          <td class="two-column-lay">
            <a
              *ngIf="
                data?.docType === 'RV' ||
                data?.docType === 'RD' ||
                data?.docType === 'RF'
              "
              href="javascript: void(0);"
              class="c-link"
              (click)="creditPdf(data.refDocNo)"
            >
              {{ data.refDocNo }}
            </a>
            <a
              *ngIf="data?.docType === 'DZ' && data?.allocNmbr?.startsWith('7')"
              href="javascript: void(0);"
              class="c-link"
              (click)="creditPdf(data.allocNmbr)"
            >
              {{ data.allocNmbr }}
            </a>
            <span
              *ngIf="
                data?.docType === 'DR' ||
                data?.docType === 'DG' ||
                data?.docType === 'DY'
              "
            >
              {{ data.refDocNo }}
            </span>
            <span
              *ngIf="
                data?.docType === 'DZ' && !data?.allocNmbr?.startsWith('7')
              "
            >
              {{ data.allocNmbr }}
            </span>
            <span *ngIf="data?.docType === 'YR'">
              {{ data.refhdr }}
            </span>
          </td>
          <td class="two-column-lay header">
            {{ 'makeAPayment.credit_amount' | cxTranslate }}
          </td>
          <td class="two-column-lay text-left">
            {{ data?.amount | currency }}
          </td>
        </tr>
      </table>
    </section>
    <section *ngIf="selectedTab === 'STATEMENTS'">
      <app-open-statements
        [hideAside]="removeAside"
        [restrictToTen]="true"
      ></app-open-statements>
    </section>
    <div
      class="invoice-btngrps"
      *ngIf="
        !!paymentList &&
        paymentList.length > 0 &&
        isLoadingDone &&
        selectedTab === 'INVOICES'
      "
    >
      <a
        type="button"
        class="c-link mb-4 mt-2 my-lg-4"
        data-di-id="di-id-41a05d18-6b04a424"
        [routerLink]="['/my-account/invoices']"
      >
        {{ 'accountOverview.Financials.button_txt' | cxTranslate }}
      </a>
    </div>
    <div
      class="invoice-btngrps"
      *ngIf="
        !!creditList &&
        creditList.length > 0 &&
        isLoadingDone &&
        selectedTab === 'CREDITS'
      "
    >
      <a
        type="button"
        class="c-link my-4"
        data-di-id="di-id-41a05d18-6b04a424"
        [routerLink]="['/my-account/invoices']"
      >
        {{ 'accountOverview.Financials.credits.credit_btn_txt' | cxTranslate }}
      </a>
    </div>
    <div
      class="invoice-btngrps"
      *ngIf="selectedTab === 'STATEMENTS' && !!isLoadingDone"
    >
      <a
        type="button"
        class="c-link my-4"
        data-di-id="di-id-41a05d18-6b04a424"
        [routerLink]="['/my-account/statements']"
      >
        {{
          'accountOverview.Financials.statements.statement_btn_txt'
            | cxTranslate
        }}
      </a>
    </div>
  </div>
</div>
<ng-template #invoicePastDueDateMsg>{{
  'accountOverview.Financials.pdf_label' | cxTranslate
}}</ng-template>
<div class="hide-section" *ngIf="isPDF">
  <div class="col-md-12" id="pdf-header">
    <h3 class="financial">
      {{ 'accountOverview.Financials.label' | cxTranslate }}
    </h3>
  </div>
  <div class="col-md-12" id="pdf-subheader">
    <h3 class="sub-label-pdf" *ngIf="selectedTab === 'INVOICES'">
      {{ 'accountOverview.Financials.invoice_label' | cxTranslate }}
    </h3>
    <h3 class="sub-label-pdf" *ngIf="selectedTab === 'CREDITS'">
      {{ 'accountOverview.Financials.credits_label' | cxTranslate }}
    </h3>
  </div>
  <div class="line-top-sanofi-pdf" id="line-sanofi"></div>
</div>
